//
// TooltipInfoController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import ClosetObject from "@sas-dvr/ltjs-commons/ClosetObject";
import "../../lib";
import "./PickResultEntryInfo";
import "@sas-dvr/ltjs-commons/pickResults/PickResult";

var TooltipInfoController = createModule("BIRD::TooltipInfoController", [], ClosetObject, [
    ,
    ,
    ,
    ,
    {
        isPickResultsReady: [2],
        getPickResults: [[1]],
        isTooltipInfoReady: [2],
        getInfoEntries: [[1]],
    },
    {
        getInfoEntriesForPickResult: [[1],1],
    },
    ,
]);
export default TooltipInfoController;
